import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger
} from '@purpose/ui/components/popover/popover';
import {cn} from '@purpose/ui/lib/utils';
import {TriangleAlert, X} from 'lucide-react';

import React, {Dispatch, SetStateAction} from 'react';

interface IWithHint {
  children: React.ReactNode;
  title: string;
  description: string;
  onOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  alert?: boolean;
  side?: 'top' | 'bottom' | 'left' | 'right';
  sideOffset?: number;
  className?: string;
  contentClassName?: string;
  xClassName?: string;
}

const WithHint = ({
  title,
  description,
  children,
  onOpen,
  open,
  side = 'bottom',
  contentClassName = '',
  xClassName = '',
  sideOffset,
  alert
}: IWithHint) => {
  return (
    <Popover open={open}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>

      <PopoverContent
        side={side}
        sideOffset={sideOffset}
        className={cn('bg-primary-110', contentClassName)}
        style={{border: 'none'}}
      >
        <X
          onClick={() => onOpen(false)}
          className={cn(
            'absolute top-2 right-2 h-4 w-4 cursor-pointer text-white opacity-50',
            xClassName
          )}
        />
        <PopoverArrow />
        <div className="flex flex-col gap-1 rounded-sm">
          <p className="flex gap-2 text-base font-semibold text-white">
            {alert && (
              <span className="my-auto inline-flex">
                <TriangleAlert className="h-5 w-5 text-white" />
              </span>
            )}
            {title}
          </p>
          <p className="text-sm text-white">{description}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default WithHint;
